import { createRoot } from "react-dom/client";

import { App } from "./app";

addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("root");
  if (!container) return;

  // The homepage ships prerendered markup so crawlers see real content, but the
  // client still mounts normally and replaces it: <App/> reads localStorage and
  // builds a browser router during render, so it cannot run in Node and there is
  // no server tree to hydrate against. The prerender is for crawlers, not for
  // startup cost — making it hydratable means changing shared auth and routing.
  const root = createRoot(container);
  root.render(<App />);
});
